module.exports = __webpack_public_path__ + "static/img/weather_037.09c11180.svg";